import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {createCacheMiddleware, createCsrfMiddleware, fetch, fetchWithHeaders} from '@yandex-delivery/core/utils/network'
import {pipe} from '@yandex-delivery/utils'

import {config as tariffsConfig} from '../../config'

type FetchWithHeaders = typeof fetchWithHeaders
type Fetch = typeof fetch

function withAcceptLanguageHeader(fetch: FetchWithHeaders): FetchWithHeaders {
  return function _withAcceptLanguageHeader(config) {
    const {headers, ...restConfig} = config

    return fetch({
      ...restConfig,
      headers: {
        ...headers,
        'Accept-Language': tariffsConfig.config.lang,
      }
    })
  }
}

function withTariffsExternalApi(fetch: FetchWithHeaders): FetchWithHeaders {
  return function _withTariffsExternalApi(config) {
    const {url, ...restConfig} = config

    return fetch({
      ...restConfig,
      url: `/api/b2b/external/dcaa/v1/tariff/${url}`
    })
  }
}

function withDefaultPostMethod(fetch: FetchWithHeaders): FetchWithHeaders {
  return function _withDefaultPostMethod(config) {
    const {method, ...restConfig} = config

    return fetch({
      ...restConfig,
      method: method || 'POST',
    })
  }
}

function withExternalApiUrl(fetch: Fetch): Fetch {
  return function _withExternalApiUrl(config) {
    const {url, ...restConfig} = config

    return fetch({
      ...restConfig,
      url: externalApiURL(url)
    })
  }
}

// Basename может быть undefined, поэтому надо быть уверенным в том, что у нас строится URL правильно
const CSRF_TOKEN_ENDPOINT_URL = typeof tariffsConfig.config.basename === 'string' && tariffsConfig.config.basename.length > 0
  ? `/${tariffsConfig.config.basename}/api/csrf_token/`
  : '/api/csrf_token/'

const withCsrfMiddleware = createCsrfMiddleware({url: CSRF_TOKEN_ENDPOINT_URL})

export const tariffsExternalFetch = pipe(
  fetchWithHeaders,
  withCsrfMiddleware,
  withAcceptLanguageHeader,
  withDefaultPostMethod,
  withTariffsExternalApi,
  createCacheMiddleware({staleTime: 1000 * 60 * 60 * 12}),
) as FetchWithHeaders

export const externalFetch = pipe(
  fetch as FetchWithHeaders,
  withCsrfMiddleware,
  withAcceptLanguageHeader,
  withExternalApiUrl
) as FetchWithHeaders
